module.exports = __webpack_public_path__ + "static/media/WelcomePanel.b8165484.md";